export const CONTACT = {
  phoneDisplay: "+971 4 296 3910",
  phone: "+97142963910",
  whatsapp: "971558650124",
  email: "info@fedari.ae",
  waMessage: "Hello Fedari, I would like an exact inspection quote and confirmed availability.",
  // Registered office (owner-provided, October 2026)
  addressLines: [
    "Office 124, Regus Deira City Centre",
    "City Centre Office Building, Port Saeed Road",
    "Deira, Dubai, United Arab Emirates",
  ],
  addressNote: "Entrance next to the Pullman Dubai Creek City Centre Hotel.",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Regus%20Deira%20City%20Centre%2C%20City%20Centre%20Office%20Building%2C%20Port%20Saeed%20Road%2C%20Deira%2C%20Dubai",
};

export const waHref = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.waMessage)}`;
export const telHref = `tel:${CONTACT.phone}`;
export const mailHref = `mailto:${CONTACT.email}`;

export const EMIRATES = ["Dubai", "Abu Dhabi", "Sharjah", "Other (subject to availability)"];
export const PROPERTY_TYPES = ["Apartment", "Villa", "Townhouse", "Penthouse", "Commercial", "Other"];
export const SERVICES = ["Snagging inspection", "Pre-handover inspection", "Handover inspection", "De-snagging / re-inspection", "DLP / warranty inspection", "Resale property inspection", "Commercial inspection"];
